import React from 'react'
import { Link } from 'react-router-dom'
import { imageUrl } from '../lib/images'

const LOGO_SRC = '/_assets/reng-logo.png'

export default function Logo({ variant = 'header', compact = false, className = '' }) {
  const isDarkFooter = variant === 'footer-dark'

  return (
    <Link
      to="/"
      className={`group inline-flex items-center transition-opacity hover:opacity-95 ${className}`}
      aria-label="Havdrup Rengøring – Forside"
    >
      {isDarkFooter ? (
        <div className="inline-flex items-center rounded-xl bg-white/95 px-3 py-2 shadow-sm ring-1 ring-white/20 transition-transform duration-200 group-hover:scale-[1.02]">
          <img
            src={imageUrl(LOGO_SRC, 'width=440,quality=90,format=auto')}
            alt="Havdrup Rengøring"
            className="h-9 sm:h-10 w-auto object-contain"
            loading="lazy"
          />
        </div>
      ) : (
        <div
          className={`origin-left transition-all duration-300 ease-out will-change-transform ${
            compact ? 'scale-90' : 'scale-100'
          }`}
        >
          <img
            src={imageUrl(LOGO_SRC, 'width=520,quality=95,format=auto')}
            alt="Havdrup Rengøring"
            className={`w-auto object-contain transition-all duration-300 ${
              compact ? 'h-9 sm:h-10' : 'h-11 sm:h-13'
            }`}
          />
        </div>
      )}
    </Link>
  )
}
